import { useEffect, useRef } from 'react';

export default function IntroSection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100', 'translate-y-0');
          entry.target.classList.remove('opacity-0', 'translate-y-6');
        }
      },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="relative py-16 lg:py-24 bg-brand-dark">
      <div className="container mx-auto px-6">
        <div
          ref={ref}
          className="max-w-4xl mx-auto text-center opacity-0 translate-y-6 transition-all duration-700"
        >
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6">
            Nous ne faisons pas que répondre à un besoin. Nous accompagnons la réussite de vos projets stratégiques.
          </p>
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6">
            Depuis 2016, ITEC Groupe est un cabinet indépendant de conseil en ingénierie, reconnu pour sa capacité à conjuguer{' '}
            <strong className="text-white">excellence opérationnelle et compréhension fine des environnements sensibles.</strong>
          </p>
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6">
            Présents en <strong className="text-white">France, Tunisie, Emirats Arabes Unis et Arabie Saoudite</strong>, nous intervenons sur des projets à haute criticité IT et industrielle.
          </p>
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-10">
            Nous sommes le partenaire de confiance des grandes organisations lorsque rigueur, exigence technique et qualité d'exécution sont non négociables.
          </p>

          <p className="text-lg font-semibold text-white mb-6">Notre ADN repose sur trois piliers :</p>

          <div className="flex flex-col gap-5 text-left max-w-2xl mx-auto">
            <div className="flex items-start gap-4 bg-brand-dark-card rounded-xl p-5 border border-white/10">
              <p className="text-gray-300 leading-relaxed">
                Une <strong className="text-white">lecture opérationnelle</strong> des contextes critiques, fondée sur l'expérience du terrain
              </p>
            </div>
            <div className="flex items-start gap-4 bg-brand-dark-card rounded-xl p-5 border border-white/10">
              <p className="text-gray-300 leading-relaxed">
                Un <strong className="text-white">haut niveau d'exigence</strong> dans la tenue des engagements et la qualité livrée
              </p>
            </div>
            <div className="flex items-start gap-4 bg-brand-dark-card rounded-xl p-5 border border-white/10">
              <p className="text-gray-300 leading-relaxed">
                Une capacité à <strong className="text-white">aligner vision stratégique, réactivité et exécution fluide</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
